// Limit to the Financial Future / landing page only (page ID 11188).
const TARGET_PAGE_CLASS = "page-id-11188";

const ICON_SELECTOR =
  ".material-icons, .material-icons-outlined, .advgb-icon, .wp-block-advgb-icon";

const CONTROL_SELECTOR = 'a, button, [role="button"], [role="link"]';

function isTargetPage() {
  return document.body.classList.contains(TARGET_PAGE_CLASS);
}

function getControlAccessibleName(control) {
  if (
    control.getAttribute("aria-label") ||
    control.getAttribute("aria-labelledby") ||
    control.getAttribute("title")
  ) {
    return true;
  }

  if (control.querySelector("img[alt]:not([alt=''])")) {
    return true;
  }

  const clone = control.cloneNode(true);
  clone
    .querySelectorAll(
      ".material-icons, .material-icons-outlined, .advgb-icon, .wp-block-advgb-icon, .screen-reader-text, .sr-only"
    )
    .forEach((node) => node.remove());

  return clone.textContent.replace(/\s+/g, " ").trim().length > 0;
}

function hideDecorativeIcons() {
  if (!isTargetPage()) {
    return;
  }

  document.querySelectorAll(ICON_SELECTOR).forEach((icon) => {
    if (icon.closest("[aria-hidden='true']")) {
      return;
    }

    const control = icon.closest(CONTROL_SELECTOR);
    if (control && !getControlAccessibleName(control)) {
      // Icon-only control with no other name — leave alone so something is announced.
      return;
    }

    icon.setAttribute("aria-hidden", "true");
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", hideDecorativeIcons);
} else {
  hideDecorativeIcons();
}
